import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsBackgroundColorSvg } from './WpsBackgroundColorSvg'

export const WpsBackgroundColorIcon = (
  props: PropsWithoutRef<IconBaseProps>
) => <Icon component={WpsBackgroundColorSvg} {...props} />
